export const CUSTOM_RULES = {
    EVENLY_DISTRIBUTED: "EVENLY_DISTRIBUTED",
    WORKLOAD_DISTRIBUTED: "WORKLOAD_DISTRIBUTED",
};
